export const Colors = {
  Blue: "#37bbc8",
  Green: "#01d765",
  Black: "#252525",
  VantaBlack: "#0f110e",
  Orange: "#ff9900",
  DarkGrey: "#3f3f3f",
  Grey: "#959595",
  LightGrey: "#cccccc",
  White: "#ffffff",
  Red: "#ff0050",
};
